<template>
  <div>
    <vue-headful title="Vacatures" />
    <Header page_title="Vacatures" />
    <div class="">
      <div class="container-fluid app-body">
        <template v-if="results">
          <div v-if="results.data && results.data.length > 0" class="mb-4">
            <JobCard
              v-for="job in results.data"
              :key="job.job_id"
              :job="job"
              :all_jobs="results.data"
              :recommended="true"
              v-model="fullscreen_notif"
            />
            <Pagination :results="results" :api="api" @page-change="pageChanged" />
          </div>
          <Empty v-else text="Er zijn geen banen beschikbaar." />
        </template>
      </div>
    </div>
    <Footer />
    <!-- You have accepted the job!
        You will receive a message quickly as to whether
    the employer has the match confirmed so you can get started!-->
    <Notification
      v-if="fullscreen_notif == 'accepted'"
      v-model="fullscreen_notif"
      text="<p>Je hebt de baan geaccepteerd!</p>
            <p class='mb-0'>Je ontvangt snel een bericht of de werkgever de match heeft bevestigd zodat je aan de slag kan!</p>"
      :show="true"
    />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";

export default {
  data: function() {
    return {
      api: "jobs/all",
      results: null,
      fullscreen_notif: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.results = await this.getListwithPages("jobs/all");
      this.$store.state.loading = false;
    },
    //   modify function to avoid error messages in parent component -jimbo
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    }
  },
  components: {
    JobCard
  }
};
</script>

<style scoped>
::v-deep .component .icon-wrapper + .details {
  width: 100%;
}
</style>
